import React, { PureComponent } from 'react';
import LoginSignUp from '../components/LoginSignUp';
import { signInWithCredentials, signUpWithCredentials } from 'modules/authentication/helpers/nextauth';

interface LoginSignUpContainerProps {
  options?: {
    gender?: boolean;
    firstname?: boolean;
    lastname?: boolean;
    country?: boolean;
    phoneCountryCode?: boolean;
    phoneNumber?: boolean;
  };
  className?: string;
  showLoginInitially?: boolean;
  companyName?: string;
  onLoginAsGuest?: () => void;
}

class LoginSignUpContainer extends PureComponent<LoginSignUpContainerProps> {

  state = {
    showSignupForm: false,
    showLogin: this.props.showLoginInitially || false,
    loginButtonLoading: false,
    signupButtonLoading: false,
    errors: {}
  };

  onShowSignupEmail = () => {
    this.setState({ showSignupForm: true, showLogin: false, errors: {} });
  };

  onShowLogin = () => {
    this.setState({ showLogin: true, showSignupForm: false, errors: {} });
  };

  onLogin = async (data: { email: string; password: string }) => {
    const searchParams = new URLSearchParams(window.location.search);
    const returnTo = searchParams.get('returnTo');
    return await signInWithCredentials(data.email, data.password, returnTo).catch((err) => {
      this.setState({
        errors: {
          validation: err.message
        }
      });
    });
  };

  onSignup = (data: {
    email: string;
    password: string;
    gender?: undefined | 'man' | 'woman' | 'other';
    firstname: string;
    lastname: string;
    country?: string;
    phoneCountryCode?: string;
    phoneNumber?: string;
  }) => {
    const phoneNumber = !!data.phoneCountryCode && data.phoneNumber ? `+${data.phoneCountryCode}${data.phoneNumber}` : data.phoneNumber;
    this.setState({ signupButtonLoading: true, errors: {} });
    // const searchParams = new URLSearchParams(window.location.search);
    const returnTo = window.location.href;

    return signUpWithCredentials({
      firstName: data.firstname,
      lastName: data.lastname,
      email: data.email,
      password: data.password,
      gender: data.gender,
      phoneNumber: phoneNumber,
      callbackUrl: returnTo
    }).catch((error) => {
      this.setState({ signupButtonLoading: false, errors: { validation: error.message } });
    })
  };

  render() {
    return (
      <LoginSignUp
        className={this.props.className}
        onShowSignupEmail={this.onShowSignupEmail}
        showSignupForm={this.state.showSignupForm}
        showLogin={this.state.showLogin}
        loginButtonLoading={this.state.loginButtonLoading}
        signupButtonLoading={this.state.signupButtonLoading}
        onShowLogin={this.onShowLogin}
        onLogin={this.onLogin}
        onSignup={this.onSignup}
        options={this.props.options || { firstname: true, lastname: true }}
        errors={this.state.errors}
        companyName={this.props.companyName}
        onLoginAsGuest={this.props.onLoginAsGuest}
      />
    );
  }
}

export default LoginSignUpContainer;
